import clsx from "clsx";
import { ArrowDown, ArrowUp, ChevronsUpDown } from "lucide-react";
import type { ReactNode } from "react";

/** How a table is sorted: by which column, and which way. */
export interface TableSort<K extends string> {
    key: K;
    desc: boolean;
}

/**
 * A column heading that sorts its table: pressed, by this column (ascending first), pressed again, the other way. The column it's
 * sorted by shows which way; the others a faint both-ways mark, so it's clear they can be.
 */
export function SortableTh<K extends string>(
    props: Readonly<{ label: ReactNode; sortKey: K; sort: TableSort<K>; onSort: (sort: TableSort<K>) => void; className?: string; title?: string }>,
) {
    const active = props.sort.key === props.sortKey;
    let Icon = ChevronsUpDown;
    if (active) Icon = props.sort.desc ? ArrowDown : ArrowUp;
    return (
        <th className={props.className} aria-sort={active ? (props.sort.desc ? "descending" : "ascending") : "none"}>
            <button
                type="button"
                className={clsx("inline-flex cursor-pointer items-center gap-1 hover:text-ink", props.className?.includes("text-right") && "flex-row-reverse")}
                title={props.title}
                onClick={() => props.onSort({ key: props.sortKey, desc: active ? !props.sort.desc : false })}
            >
                {props.label}
                <Icon className={clsx("size-3.5 shrink-0", !active && "opacity-40")} />
            </button>
        </th>
    );
}
